import { render, staticRenderFns } from "./KPIWidget.vue?vue&type=template&id=3dc0f71b&scoped=true"
import script from "./KPIWidget.vue?vue&type=script&lang=js"
export * from "./KPIWidget.vue?vue&type=script&lang=js"
import style0 from "./KPIWidget.vue?vue&type=style&index=0&id=3dc0f71b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0f71b",
  null
  
)

export default component.exports